import Statistics from "../apis/Statistics";

const common = {
    data() {
        return {
            fileInProgress: false
        }
    },
    methods: {
        /**
         * @param {Boolean} value - success snackbar visibility value
        */
        handleUpdateToSuccessSnackbar(value) {
            this.success = value;
        },
        /**
         * @param {Boolean} value - failure snackbar visibility value
        */
        handleUpdateToFailureSnackbar(value) {
            this.failure = value;
        },
        /**
         * @param {String, Object, Array} text - text needs to be copied
         * @return {Promise}
        */
        writeTextToClipboard(value) {
            let formattedValue = typeof value === "object" ? JSON.stringify(value, null, 2) : value;

            return new Promise((resolve, reject) => {
                navigator.clipboard.writeText(formattedValue)
                    .then(() => {
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * @return {Promise} Promise returns the files list
         */
        getFilesList() {
            return new Promise((resolve, reject) => {
                Statistics.getCSVList()
                    .then((response) => {
                        this.files = response.data.data;

                        return response.data.data;
                    })
                    .then((files) => {
                        resolve(files);
                    })
                    .catch((error) => {
                        reject(error);

                        if (
                            error.response.status === 401 ||
                            error.response.status === 419
                        ) {
                            this.$router.push({ name: "Login" });
                        }
                    });
            });
        },
        /**
         * /**
         * Check Status Of File Downloading
         */
        checkFileStatus() {
            var lastEl = null;
            let files = [];
            let interval = null;

            this.getFilesList()
                .then((response) => {
                    files = response;

                    if (files.in_progress && files.in_progress.length) {
                        this.fileInProgress = true;

                        if (undefined !== this.items && this.items.length) {
                            this.items.findLast(el => el.size = files.in_progress[0].size)
                        }

                        //interval = setInterval(this.checkFileStatus(), 15000);
                    } else {
                        setTimeout(() => {
                            this.fileInProgress = false;
                        }, 1000);

                        if (undefined !== this.items && this.items.length) {
                            files.ready.findLast(el =>
                                lastEl = el
                            );

                            this.items.at(-1).size = lastEl.size;
                            this.items.at(-1).link = lastEl.link;
                        }

                        if (null !== interval) {
                            clearInterval(interval);
                        }
                    }
                });
        },
        /**
         * /**
         * @param {STRING} param - url to open in the new tab
         */
        openTab(url) {
            if (!url || typeof url !== "string") {
                throw new Error("openLink function: Invalid argument.");
            }

            window.open(url, "_blank").focus();
        },
    }
}

export default common;